import { OrderStatusEnum } from 'types/graphql';
import { BiddableShiftStatus, ShiftBiddingStatusParams } from 'components/Tags/Tags.types';
import { DateTime } from 'luxon';

export const getShiftBiddingStatus = ({
  status,
  biddable,
  awardingTimeStartsAt,
  biddingTimeEndsAt,
  bids,
  timeZone,
}: ShiftBiddingStatusParams): Nullable<BiddableShiftStatus> => {
  const safeBids = bids || [];
  if (status === OrderStatusEnum.accepted && !!biddable && safeBids.length > 0) {
    return 'AWARDED';
  }
  if (status === OrderStatusEnum.pending && !!biddable) {
    if (
      !!awardingTimeStartsAt &&
      DateTime.fromISO(awardingTimeStartsAt, { zone: timeZone }) < DateTime.now() &&
      safeBids.length > 0
    ) {
      return 'AWARDING';
    }
    if (
      !!biddingTimeEndsAt &&
      DateTime.fromISO(biddingTimeEndsAt, { zone: timeZone }) > DateTime.now()
    ) {
      return 'BIDDING';
    }
    if (
      (!biddingTimeEndsAt ||
        DateTime.fromISO(biddingTimeEndsAt, { zone: timeZone }) < DateTime.now()) &&
      safeBids.length === 0
    ) {
      return 'NO_BIDS';
    }
  }
  return null;
};
